/**
 * FullCalendar Premium commercial licence key (v7.x).
 *
 * Do NOT commit real keys to tracked `.env.*` files (gitleaks).
 *
 * Local development:
 *   Create `.env.development.local` (gitignored) with:
 *     REACT_APP_FULLCALENDAR_LICENSE_KEY=<your-key>
 *
 * CI / deploy:
 *   Set GitHub Actions secret `REACT_APP_FULLCALENDAR_LICENSE_KEY`.
 *   Workflows inject it into the env file before build.
 *
 * Purchase / docs: https://fullcalendar.io/purchase
 */
export const FULLCALENDAR_LICENSE_KEY =
	process.env.REACT_APP_FULLCALENDAR_LICENSE_KEY || '';
